import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { useSendFormActions, useSendFormState } from './_form/SendFormHandler'
import Modal from '../../../components/structure/Modal'
import SendFormForm from './SendFormForm'
import Separator from '../../../components/helpers/Separator'
import { COLORS } from '@btime/constants'

const SendFormModal = () => {
  const { t } = useTranslation('sendForm')
  const { open, places } = useSendFormState()
  const { closeSendFormModal } = useSendFormActions()

  return (
    <Modal open={open} onClose={closeSendFormModal}>
      <Title size="h4" noMargin align="center">
        {t('title')}
      </Title>
      <SmallText color={COLORS.dark3} align="center">
        {t('subtitle')}
      </SmallText>

      <Separator weight={8} />

      <SendFormForm />
    </Modal>
  )
}

export default SendFormModal
